import React from "react";
import { useCountdown } from "../hooks/useCountdown";
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  return <div className="w-full" role="timer" aria-live="off" data-id="element-21" data-mp="3q15cw8rojys0">
      <p className="text-center text-sm font-bold uppercase tracking-wide text-danger" data-id="element-22" data-mp="3pzkjimh3qlvq">
        The promotional price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-23" data-mp="3h1idttmfb524">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="324hxsndlgyjh" data-mpi={i}>
            <div className="flex w-[72px] flex-col items-center rounded-xl bg-ink py-3 sm:w-24" data-id="element-25" data-mp="325ja0v6cjr2s">
              <span className="font-display text-[34px] font-black leading-none tabular-nums text-white sm:text-5xl" data-id="element-26" data-mp="3731fucp2hq6k">{u.value}</span>
              <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-white/70" data-id="element-27" data-mp="15b6b6h18alxu">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-3 font-display text-3xl font-black text-ink sm:text-4xl" aria-hidden="true" data-id="element-28" data-mp="xytue8i8wn21">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}